/* ══════════════════════════════════════════
   WOYIN TAYLOR — Add to Bag (AJAX)
   Place in assets/wt-collection.js
   Reference in layout/theme.liquid before </body>:
   {{ 'wt-collection.js' | asset_url | script_tag }}
   ══════════════════════════════════════════ */

function wtAddToBag(btn, variantId) {
  if (btn.disabled) return;

  var original = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(res) { return res.json(); })
  .then(function(data) {
    btn.textContent = 'Added';

    /* Update cart count bubble */
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden]');
        bubbles.forEach(function(b) { b.textContent = cart.item_count; });
      });

    /* Fetch and re-render cart drawer contents */
    fetch('/?section_id=cart-drawer')
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('cart-drawer');
        var currentDrawer = document.querySelector('cart-drawer');
        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
        }
        /* Open drawer after contents are updated */
        var drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.open(btn);
      });

    setTimeout(function() {
      btn.textContent = BTN_LABEL;
      btn.disabled = false;
    }, 1800);
  })
  .catch(function() {
    btn.textContent = 'Error — try again';
    setTimeout(function() {
      btn.textContent = BTN_LABEL;
      btn.disabled = false;
    }, 2000);
  });
}